/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export const PAGINATION = {
	sizes: [10, 25, 50],
};
export const SINGLE_RECORD = 1;
